// Class-name joiner that lets a later Tailwind class override an earlier one (from
// isomorphic-core/src/utils/class-names.ts).
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
